import React from "react";
import EducationPlatform from "./components/EducationPlatform";

function App() {
  return <EducationPlatform />;
}

export default App;
